/**
 * Hook to dynamically load Google AdSense script
 * Only loads the script once, even if multiple components use this hook
 */

import { useEffect } from 'react'

const ADSENSE_CLIENT_ID = 'ca-pub-2807042302450203'
const ADSENSE_SCRIPT_ID = 'google-adsense-script'

export const useAdSense = () => {
  useEffect(() => {
    // Check if script is already loaded
    if (document.getElementById(ADSENSE_SCRIPT_ID)) {
      return
    }

    // Create and append the AdSense script
    const script = document.createElement('script')
    script.id = ADSENSE_SCRIPT_ID
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`
    script.async = true
    script.crossOrigin = 'anonymous'

    document.head.appendChild(script)

    // Cleanup function (optional - removes script when all components using it unmount)
    return () => {
      const existingScript = document.getElementById(ADSENSE_SCRIPT_ID)
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])
}
